<template>
    <div v-if="!isLoading" class="blogs-page wrapper">
      <div class="columns is-tablet">
          <div class="column is-9-tablet is-12-mobile is-9-widescreen is-9-fullhd">
            <back-button class="mb-5"/>
            <Calculator></Calculator>
          </div>
          <div ref="subRight_before" class="column is-12-mobile is-3-widescreen">
            <div class="banner-on-top" ref="subRight">
              <AdsGoogle />
            </div>
          </div>
      </div>
    </div>
    <div class="preloader-center" v-else>
        <Preloader />
    </div>
</template>
<script>
import bannerMixin from "@/mixins/bannerMixin";
import Preloader from "@/components/Preloader";
import BackButton from "@/components/BackButton";
import Calculator from "../components/Calculator.vue";
import commonMixin from "@/mixins/commonMixin";
import AdsGoogle from '@/components/AdsGoogle.vue';
export default {
    name: 'CompoundReturnCalculator',
    components: { Preloader, BackButton, Calculator, AdsGoogle },
    mixins: [bannerMixin, commonMixin],
    data: function () {
        return {
            isLoading: false
        }
    },
    metaInfo() {
        return {
            title: "Compound returns calculator | Pickafund",
            meta: [
                {
                    name: "description",
                    content:
                        "Calculate the required rate of return for your investment and explore which category of funds would have attained this in the past.",
                },
                { property: "og:title", content: "Compound returns calculator | Pickafund" },
            ],
        };
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>
<style scoped lang="scss">
.title-page {
  padding-bottom: 0.75rem;
}
#inputs {
  border: dashed black 1px;
  border-radius: 15px;
  padding: 20px;
  margin-top: 10px;
  margin-left: 20px;
  width: 65%;
}
.table-rate {
  margin-top: 20px;
  margin-left: 20px;
}
</style>